import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";

import { HOLIDAYS } from "@config/testIds/holidays";

import { InfoMessage, ModalHeader } from "@ui/Molecules";

import { useTranslate } from "@hooks/useTranslate";

import { Modal } from "@app/containers/Modal";
import { useModalStore } from "@app/hooks/useModalStore";
import { OPTIONS_MODALS } from "@app/pages/ClientDashboard/OptionsDashboard.modals";
import { updateProcessedHoliday } from "@app/redux/holidays/holidays.actions";
import { getProcessedHoliday } from "@app/redux/holidays/holidays.selectors";

interface Props {
  onModalSubmit: (holidayId?: string) => void;
}

const CleaningForHolidays = (props: Props): React.ReactElement => {
  const { hideModal } = useModalStore();
  const translate = useTranslate();

  const dispatch = useDispatch();

  const processedHoliday = useSelector(getProcessedHoliday);

  const handleBtnClick = (skipCleanings: boolean) => {
    dispatch(
      updateProcessedHoliday({
        skipCleanings,
      }),
    );
    hideModal(OPTIONS_MODALS.CLEANING_FOR_HOLIDAYS);

    /** No Pause Cleanings -> finish flow */
    props.onModalSubmit(processedHoliday?.get("id"));
  };

  return (
    <Modal
      title={""}
      customHeader={
        <StyledModalHeader>
          {translate("batmaid_pwa_holidays.cleaning_for_holidays_question")}
        </StyledModalHeader>
      }
      withCloseBtn={false}
      cancelText={translate("batmaid_pwa_generic.answer_no")}
      submitText={translate("batmaid_pwa_generic.answer_yes")}
      id={OPTIONS_MODALS.CLEANING_FOR_HOLIDAYS}
      submit={() => handleBtnClick(false)}
      cancel={() => handleBtnClick(true)}
      testId={HOLIDAYS.HOLIDAYS_SKIP_CLEANINGS_MODAL}
      submitBtnColor="blue"
    >
      <InfoMessage
        message={translate(
          "batmaid_pwa_holidays.cleaning_for_holidays_cancel_info",
        )}
      />
    </Modal>
  );
};

CleaningForHolidays.displayName = "CleaningForHolidays";

export { CleaningForHolidays };

const StyledModalHeader = styled(ModalHeader)`
  font-size: ${props => props.theme.fonts.sizes.body};
`;
